// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lm-Widget {
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    cursor: default
}

.lm-DockPanel-handle.lm-mod-hidden,.lm-Widget.lm-mod-hidden {
    display: none!important
}

.lm-DockPanel {
    z-index: 0;
    flex: 1 1 auto
}

.lm-DockPanel-widget {
    z-index: 0
}

.lm-DockPanel-tabBar {
    z-index: 1
}

.lm-DockPanel-handle {
    z-index: 2
}

.lm-DockPanel-handle:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: ''
}

.lm-DockPanel-handle[data-orientation=horizontal] {
    cursor: ew-resize
}

.lm-DockPanel-handle[data-orientation=vertical] {
    cursor: ns-resize
}

.lm-DockPanel-handle[data-orientation=horizontal]:after {
    left: 50%;
    min-width: 8px;
    transform: translateX(-50%)
}

.lm-DockPanel-handle[data-orientation=vertical]:after {
    top: 50%;
    min-height: 8px;
    transform: translateY(-50%)
}

.lm-DockPanel-overlay {
    z-index: 3;
    box-sizing: border-box;
    pointer-events: none;
    background: rgba(255,255,255,.6);
    border: 1px dashed #000;
    transition-property: top,left,right,bottom;
    transition-duration: 150ms;
    transition-timing-function: ease
}

.lm-DockPanel-overlay.lm-mod-hidden {
    display: none!important
}

.lm-TabBar {
    min-height: 30px;
    max-height: 30px
}

.lm-TabBar li {
    margin: 0
}

.lm-TabBar-content {
    min-width: 0;
    min-height: 0;
    align-items: flex-end;
    border-bottom: 1px solid silver
}

.lm-TabBar[data-placement=bottom] .lm-TabBar-content {
    border: unset;
    border-top: 1px solid silver
}

.lm-TabBar-tab {
    padding: 0 10px;
    background: #e5e5e5;
    border: 1px solid silver;
    border-bottom: none;
    font: 18px;
    flex: 0 1 155px;
    min-height: 25px;
    max-height: 25px;
    min-width: 35px;
    margin-left: -1px;
    line-height: 25px;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px
}

.lm-TabBar-tabLabel .lm-TabBar-tabInput {
    padding: 0;
    border: 0;
    font: 18px
}

.lm-TabBar-tab:hover:not(.lm-mod-current) {
    background: #f0f0f0
}

.lm-TabBar-tab:first-child {
    margin-left: 0
}

.lm-TabBar-tab.lm-mod-current {
    min-height: 28px;
    max-height: 28px;
    background: #fff;
    transform: translateY(1px);
    border-top: 2px solid #119dff
}

.lm-TabPanel .lm-TabBar {
    margin-top: 1px
}

.lm-TabPanel .lm-TabBar[data-placement=bottom] {
    margin-top: -1px
}

.lm-TabPanel .lm-TabBar[data-placement=bottom] .lm-TabBar-tab {
    transform: translateY(-3px);
    border-top: unset;
    border-radius: 0 0 5px 5px
}

.lm-TabPanel .lm-TabBar[data-placement=bottom] .lm-TabBar-tab.lm-mod-current {
    transform: translateY(-2px);
    border-bottom: 2px solid #119dff;
    border-radius: 0 0 5px 5px
}

.lm-TabBar-tabCloseIcon,.lm-TabBar-tabIcon,.lm-TabBar-tabLabel {
    display: inline-block
}

.lm-TabBar-tabIcon {
    margin-top: 7px;
    padding-right: 3px
}

.lm-TabBar-tabCloseIcon,.lm-TabBar-tabLabel {
    margin-top: 2px
}

.lm-TabBar-tab.lm-mod-closable>.lm-TabBar-tabCloseIcon {
    margin-left: 4px
}

.lm-TabBar-tab.lm-mod-closable>.lm-TabBar-tabCloseIcon:before {
    content: '\\f00d';
    font-family: FontAwesome
}

.lm-TabBar-tab.lm-mod-drag-image {
    min-height: 26px;
    max-height: 26px;
    min-width: 155px;
    border: 0;
    box-shadow: 1px 1px 2px rgba(0,0,0,.3);
    transform: translateX(-40%) translateY(-58%)
}

.lm-Menu {
    z-index: 10000;
    position: absolute;
    white-space: nowrap;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.lm-Menu-content {
    margin: 0;
    padding: 0;
    display: table;
    list-style-type: none
}

.lm-Menu-item {
    display: table-row;
    outline: 0;
    border: none;
}

.lm-Menu-item:active, .lm-Menu-item:focus, .lm-Menu-item:hover,   .lm-Menu-item:visited  {
    outline: 0;
    border: none;
  }

.lm-Menu-item.lm-mod-collapsed,.lm-Menu-item.lm-mod-hidden {
    display: none!important
}

.lm-Menu-itemIcon,.lm-Menu-itemSubmenuIcon {
    display: table-cell;
    text-align: center
}

.lm-Menu-itemLabel {
    display: table-cell;
    text-align: left
}

.lm-Menu-itemShortcut {
    display: table-cell;
    text-align: right
}

.lm-Menu {
    padding: 3px 0;
    background: #fff;
    color: rgba(0,0,0,.87);
    border: 1px solid silver;
    font: 20px;
    box-shadow: 0 1px 6px rgba(0,0,0,.2)
}

.lm-Menu-item.lm-mod-active {
    background: #e5e5e5
}

.lm-Menu-item.lm-mod-disabled {
    color: rgba(0,0,0,.25)
}

.lm-Menu-itemIcon {
    width: 21px;
    padding: 4px 2px
}

.lm-Menu-itemLabel {
    padding: 4px 35px 4px 2px
}

.lm-Menu-itemMnemonic {
    text-decoration: underline
}

.lm-Menu-itemShortcut {
    padding: 4px 0
}

.lm-Menu-itemSubmenuIcon {
    width: 16px;
    padding: 4px 0
}

.lm-Menu-item[data-type=separator]>div {
    padding: 0;
    height: 9px
}

.lm-Menu-item[data-type=separator]>div::after {
    content: '';
    display: block;
    position: relative;
    top: 4px;
    border-top: 1px solid #ddd
}

.lm-Menu-itemIcon::before,.lm-Menu-itemSubmenuIcon::before {
    font-family: FontAwesome
}

.lm-Menu-item.lm-mod-toggled>.lm-Menu-itemIcon::before {
    content: '\\f00c'
}

.lm-Menu-item[data-type=submenu]>.lm-Menu-itemSubmenuIcon::before {
    content: '\\f0da'
}

.lm-MenuBar {
    outline: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.lm-MenuBar-content {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    list-style-type: none
}

.lm-MenuBar-item {
    box-sizing: border-box
}

.lm-MenuBar-itemIcon,.lm-MenuBar-itemLabel {
    display: inline-block
}

.lm-MenuBar {
    padding-left: 5px;
    background: #fafafa;
    color: rgba(0,0,0,.87);
    border-bottom: 1px solid #ddd;
    font: 20px
}

.lm-MenuBar-menu {
    transform: translateY(-1px)
}

.lm-MenuBar-item {
    padding: 4px 8px;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    margin-bottom: 0;
    margin-top: 0
}

.lm-MenuBar-item.lm-mod-active {
    background: #e5e5e5
}

.lm-MenuBar.lm-mod-active .lm-MenuBar-item.lm-mod-active {
    z-index: 10001;
    background: #fff;
    border-left: 1px solid silver;
    border-right: 1px solid silver;
    box-shadow: 0 0 6px rgba(0,0,0,.2)
}

.lm-ScrollBar {
    display: flex;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.lm-ScrollBar[data-orientation=horizontal] {
    flex-direction: row
}

.lm-ScrollBar[data-orientation=vertical] {
    flex-direction: column
}

.lm-ScrollBar-button,.lm-ScrollBar-track {
    box-sizing: border-box;
    flex: 0 0 auto
}

.lm-ScrollBar-track {
    position: relative;
    overflow: hidden;
    flex: 1 1 auto
}

.lm-ScrollBar-thumb {
    box-sizing: border-box;
    position: absolute
}

.lm-SplitPanel-child {
    z-index: 0
}

.lm-SplitPanel-handle {
    z-index: 1
}

.lm-SplitPanel-handle.lm-mod-hidden {
    display: none!important
}

.lm-SplitPanel-handle:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: ''
}

.lm-SplitPanel[data-orientation=horizontal]>.lm-SplitPanel-handle {
    cursor: ew-resize
}

.lm-SplitPanel[data-orientation=vertical]>.lm-SplitPanel-handle {
    cursor: ns-resize
}

.lm-SplitPanel[data-orientation=horizontal]>.lm-SplitPanel-handle:after {
    left: 50%;
    min-width: 8px;
    transform: translateX(-50%)
}

.lm-SplitPanel[data-orientation=vertical]>.lm-SplitPanel-handle:after {
    top: 50%;
    min-height: 8px;
    transform: translateY(-50%)
}

.lm-TabBar {
    display: flex;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

.lm-TabBar[data-orientation=horizontal],.lm-TabBar[data-orientation=horizontal]>.lm-TabBar-content {
    flex-direction: row
}

.lm-TabBar[data-orientation=vertical],.lm-TabBar[data-orientation=vertical]>.lm-TabBar-content {
    flex-direction: column
}

.lm-TabBar-content {
    margin: 0;
    padding: 0;
    display: flex;
    flex: 1 1 auto;
    list-style-type: none
}

.lm-TabBar-tab {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    overflow: hidden
}

.lm-TabBar-tabCloseIcon,.lm-TabBar-tabIcon {
    flex: 0 0 auto
}

.lm-TabBar-tabLabel {
    flex: 1 1 auto;
    overflow: hidden;
    white-space: nowrap
}

.lm-TabBar-tabInput {
    user-select: all;
    width: 100%;
    box-sizing: border-box
}

.lm-TabBar-tab.lm-mod-hidden {
    display: none!important
}

.lm-TabBar.lm-mod-dragging .lm-TabBar-tab {
    position: relative
}

.lm-TabBar.lm-mod-dragging[data-orientation=horizontal] .lm-TabBar-tab {
    left: 0;
    transition: left 150ms ease
}

.lm-TabBar.lm-mod-dragging[data-orientation=vertical] .lm-TabBar-tab {
    top: 0;
    transition: top 150ms ease
}

.lm-TabBar.lm-mod-dragging .lm-TabBar-tab.lm-mod-dragging {
    transition: none
}

.lm-TabPanel-tabBar {
    z-index: 1
}

.lm-TabPanel .lm-TabBar-tab[data-placement=bottom]>.lm-TabBar-content {
    background: tomato
}

.lm-TabPanel-stackedPanel {
    z-index: 0
}

.lm-BoxPanel,.lm-SplitPanel {
    flex: 1 1 auto
}

.lm-DockPanel {
    padding: 4px
}

.lm-Panel,body {
    padding: 0;
    margin: 0
}

.lm-DockPanel-widget {
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);
    border-bottom: 1px solid silver;
    border-left: 1px solid silver;
    border-right: 1px solid silver;
}

.lm-Widget {
    display: flex
}

body {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden
}

.lm-content,.lm-content>div {
    flex: 1 1 auto;
    border: 1px solid silver
}

.lm-content,.lm-panel,body {
    display: flex;
    flex-direction: column
}

.lm-content,.lm-panel {
    min-width: 50px;
    min-height: 50px;
    height: unset;
    width: unset;
    padding: 8px
}

.lm-content {
    border-top: none;
    background: #fff;
    box-shadow: 1px 1px 2px rgba(0,0,0,.2)
}

.lm-panel {
    flex: 1 1 auto
}

.lm-content>div {
    overflow: auto;
    padding: 5px
}

.lm-DockPanel {
    box-shadow: inset 0 0 4px 0 rgba(0,0,0,.5)
}

._dash-loading {
    position: relative;
    top: 40vh;
    left: 40vw;
    font-size: 50px;
    color: #888;
    overflow: hidden;
    width: 20%;
    text-align: center
}

.tabBarContainer {
    background: #eee;
    max-width: 35px;
    min-width: 35px;
    padding: 7px 0 0
}

.lm-SideBar {
    min-width: 35px;
    max-width: 35px;
    margin-left: 2px
}

.lm-SideBar.p-TabBar {
    min-height: 35px;
    max-height: 35px;
    overflow: visible;
    display: block;
    min-width: fit-content
}

.lm-SideBar .p-TabBar-content {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: stretch;
    list-style-type: none;
    height: 33px;
    transform-origin: 0 0 0
}

.lm-SideBar .p-TabBar-tab {
    padding: 0 16px;
    margin-left: -1px;
    overflow: visible;
    min-width: fit-content;
    border: 1px solid #999;
    transform: translateY(3px)
}

.lm-SideBar .p-TabBar-tab.p-mod-current {
    min-height: 32px;
    max-height: 32px;
    border-top: 2px solid #119dff
}

.lm-SideBar .p-TabBar-tabIcon.lm-SideBar-tabIcon {
    min-width: 28px;
    min-height: 28px;
    background-size: 28px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center
}

.lm-SideBar .p-TabBar-tabLabel {
    margin-top: 3px;
    transform: rotate(.1deg);
    margin-right: 6px
}

.lm-SideBar .p-TabBar-tab:hover:not(.p-mod-current) {
    background: #eee
}

.lm-SideBar.p-TabBar.lm-mod-left .p-TabBar-content {
    flex-direction: row-reverse;
    transform: rotate(-90deg) translateX(-100%)
}

.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-content {
    flex-direction: row;
    transform: rotate(90deg) translateY(-31px)
}

.tabBarContainer::after {
    margin-top: -10px;
    min-height: 100vh;
    min-width: 100%;
    content: "";
    border-right: 1px solid silver;
    border-left: 1px solid silver;
    background: 0 0;
    position: absolute
}

.lm-SideBar .p-TabBar-tab.p-mod-current {
    transform: translateY(1px);
    border-bottom: 1px solid #fff
}

.lm-SideBar .p-TabBar-tab {
    border-bottom: 1px solid silver;
    min-height: 30px;
    max-height: 30px
}

.lm-SideBar .p-TabBar-tabIcon {
    transform: rotate(-90deg);
    margin: unset
}

.lm-SideBar .p-TabBar-tabIcon.fa {
    margin: unset;
    transform: rotate(90deg) translate(3px,14px);
    margin-left: 12px
}

.lm-SideBar.p-TabBar.lm-mod-left .p-TabBar-tab.p-mod-current .p-TabBar-tabIcon {
    transform: rotate(90deg) translate(2.5px,14.5px)
}

.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-tabIcon.fa {
    transform: rotate(-90deg) translate(0,1px)
}

.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-tab.p-mod-current .p-TabBar-tabIcon {
    transform: rotate(-90deg) translate(.5px,1.5px)
}

.lm-SideBar .p-TabBar-tabLabel:empty {
    display: none
}`, "",{"version":3,"sources":["webpack://./src/lib/components/css/defaults.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI,QAAQ;IACR,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,0CAA0C;IAC1C,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sCAAsC;IACtC,2BAA2B;IAC3B;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,sCAAsC;IACtC;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;EACd;;AAEF;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,mCAAmC;IACnC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI,QAAQ;IACR,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;IACI,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".lm-Widget {\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n    cursor: default\n}\n\n.lm-DockPanel-handle.lm-mod-hidden,.lm-Widget.lm-mod-hidden {\n    display: none!important\n}\n\n.lm-DockPanel {\n    z-index: 0;\n    flex: 1 1 auto\n}\n\n.lm-DockPanel-widget {\n    z-index: 0\n}\n\n.lm-DockPanel-tabBar {\n    z-index: 1\n}\n\n.lm-DockPanel-handle {\n    z-index: 2\n}\n\n.lm-DockPanel-handle:after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: ''\n}\n\n.lm-DockPanel-handle[data-orientation=horizontal] {\n    cursor: ew-resize\n}\n\n.lm-DockPanel-handle[data-orientation=vertical] {\n    cursor: ns-resize\n}\n\n.lm-DockPanel-handle[data-orientation=horizontal]:after {\n    left: 50%;\n    min-width: 8px;\n    transform: translateX(-50%)\n}\n\n.lm-DockPanel-handle[data-orientation=vertical]:after {\n    top: 50%;\n    min-height: 8px;\n    transform: translateY(-50%)\n}\n\n.lm-DockPanel-overlay {\n    z-index: 3;\n    box-sizing: border-box;\n    pointer-events: none;\n    background: rgba(255,255,255,.6);\n    border: 1px dashed #000;\n    transition-property: top,left,right,bottom;\n    transition-duration: 150ms;\n    transition-timing-function: ease\n}\n\n.lm-DockPanel-overlay.lm-mod-hidden {\n    display: none!important\n}\n\n.lm-TabBar {\n    min-height: 30px;\n    max-height: 30px\n}\n\n.lm-TabBar li {\n    margin: 0\n}\n\n.lm-TabBar-content {\n    min-width: 0;\n    min-height: 0;\n    align-items: flex-end;\n    border-bottom: 1px solid silver\n}\n\n.lm-TabBar[data-placement=bottom] .lm-TabBar-content {\n    border: unset;\n    border-top: 1px solid silver\n}\n\n.lm-TabBar-tab {\n    padding: 0 10px;\n    background: #e5e5e5;\n    border: 1px solid silver;\n    border-bottom: none;\n    font: 18px;\n    flex: 0 1 155px;\n    min-height: 25px;\n    max-height: 25px;\n    min-width: 35px;\n    margin-left: -1px;\n    line-height: 25px;\n    box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px\n}\n\n.lm-TabBar-tabLabel .lm-TabBar-tabInput {\n    padding: 0;\n    border: 0;\n    font: 18px\n}\n\n.lm-TabBar-tab:hover:not(.lm-mod-current) {\n    background: #f0f0f0\n}\n\n.lm-TabBar-tab:first-child {\n    margin-left: 0\n}\n\n.lm-TabBar-tab.lm-mod-current {\n    min-height: 28px;\n    max-height: 28px;\n    background: #fff;\n    transform: translateY(1px);\n    border-top: 2px solid #119dff\n}\n\n.lm-TabPanel .lm-TabBar {\n    margin-top: 1px\n}\n\n.lm-TabPanel .lm-TabBar[data-placement=bottom] {\n    margin-top: -1px\n}\n\n.lm-TabPanel .lm-TabBar[data-placement=bottom] .lm-TabBar-tab {\n    transform: translateY(-3px);\n    border-top: unset;\n    border-radius: 0 0 5px 5px\n}\n\n.lm-TabPanel .lm-TabBar[data-placement=bottom] .lm-TabBar-tab.lm-mod-current {\n    transform: translateY(-2px);\n    border-bottom: 2px solid #119dff;\n    border-radius: 0 0 5px 5px\n}\n\n.lm-TabBar-tabCloseIcon,.lm-TabBar-tabIcon,.lm-TabBar-tabLabel {\n    display: inline-block\n}\n\n.lm-TabBar-tabIcon {\n    margin-top: 7px;\n    padding-right: 3px\n}\n\n.lm-TabBar-tabCloseIcon,.lm-TabBar-tabLabel {\n    margin-top: 2px\n}\n\n.lm-TabBar-tab.lm-mod-closable>.lm-TabBar-tabCloseIcon {\n    margin-left: 4px\n}\n\n.lm-TabBar-tab.lm-mod-closable>.lm-TabBar-tabCloseIcon:before {\n    content: '\\f00d';\n    font-family: FontAwesome\n}\n\n.lm-TabBar-tab.lm-mod-drag-image {\n    min-height: 26px;\n    max-height: 26px;\n    min-width: 155px;\n    border: 0;\n    box-shadow: 1px 1px 2px rgba(0,0,0,.3);\n    transform: translateX(-40%) translateY(-58%)\n}\n\n.lm-Menu {\n    z-index: 10000;\n    position: absolute;\n    white-space: nowrap;\n    overflow-x: hidden;\n    overflow-y: auto;\n    outline: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.lm-Menu-content {\n    margin: 0;\n    padding: 0;\n    display: table;\n    list-style-type: none\n}\n\n.lm-Menu-item {\n    display: table-row;\n    outline: 0;\n    border: none;\n}\n\n.lm-Menu-item:active, .lm-Menu-item:focus, .lm-Menu-item:hover,   .lm-Menu-item:visited  {\n    outline: 0;\n    border: none;\n  }\n\n.lm-Menu-item.lm-mod-collapsed,.lm-Menu-item.lm-mod-hidden {\n    display: none!important\n}\n\n.lm-Menu-itemIcon,.lm-Menu-itemSubmenuIcon {\n    display: table-cell;\n    text-align: center\n}\n\n.lm-Menu-itemLabel {\n    display: table-cell;\n    text-align: left\n}\n\n.lm-Menu-itemShortcut {\n    display: table-cell;\n    text-align: right\n}\n\n.lm-Menu {\n    padding: 3px 0;\n    background: #fff;\n    color: rgba(0,0,0,.87);\n    border: 1px solid silver;\n    font: 20px;\n    box-shadow: 0 1px 6px rgba(0,0,0,.2)\n}\n\n.lm-Menu-item.lm-mod-active {\n    background: #e5e5e5\n}\n\n.lm-Menu-item.lm-mod-disabled {\n    color: rgba(0,0,0,.25)\n}\n\n.lm-Menu-itemIcon {\n    width: 21px;\n    padding: 4px 2px\n}\n\n.lm-Menu-itemLabel {\n    padding: 4px 35px 4px 2px\n}\n\n.lm-Menu-itemMnemonic {\n    text-decoration: underline\n}\n\n.lm-Menu-itemShortcut {\n    padding: 4px 0\n}\n\n.lm-Menu-itemSubmenuIcon {\n    width: 16px;\n    padding: 4px 0\n}\n\n.lm-Menu-item[data-type=separator]>div {\n    padding: 0;\n    height: 9px\n}\n\n.lm-Menu-item[data-type=separator]>div::after {\n    content: '';\n    display: block;\n    position: relative;\n    top: 4px;\n    border-top: 1px solid #ddd\n}\n\n.lm-Menu-itemIcon::before,.lm-Menu-itemSubmenuIcon::before {\n    font-family: FontAwesome\n}\n\n.lm-Menu-item.lm-mod-toggled>.lm-Menu-itemIcon::before {\n    content: '\\f00c'\n}\n\n.lm-Menu-item[data-type=submenu]>.lm-Menu-itemSubmenuIcon::before {\n    content: '\\f0da'\n}\n\n.lm-MenuBar {\n    outline: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.lm-MenuBar-content {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    list-style-type: none\n}\n\n.lm-MenuBar-item {\n    box-sizing: border-box\n}\n\n.lm-MenuBar-itemIcon,.lm-MenuBar-itemLabel {\n    display: inline-block\n}\n\n.lm-MenuBar {\n    padding-left: 5px;\n    background: #fafafa;\n    color: rgba(0,0,0,.87);\n    border-bottom: 1px solid #ddd;\n    font: 20px\n}\n\n.lm-MenuBar-menu {\n    transform: translateY(-1px)\n}\n\n.lm-MenuBar-item {\n    padding: 4px 8px;\n    border-left: 1px solid transparent;\n    border-right: 1px solid transparent;\n    margin-bottom: 0;\n    margin-top: 0\n}\n\n.lm-MenuBar-item.lm-mod-active {\n    background: #e5e5e5\n}\n\n.lm-MenuBar.lm-mod-active .lm-MenuBar-item.lm-mod-active {\n    z-index: 10001;\n    background: #fff;\n    border-left: 1px solid silver;\n    border-right: 1px solid silver;\n    box-shadow: 0 0 6px rgba(0,0,0,.2)\n}\n\n.lm-ScrollBar {\n    display: flex;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.lm-ScrollBar[data-orientation=horizontal] {\n    flex-direction: row\n}\n\n.lm-ScrollBar[data-orientation=vertical] {\n    flex-direction: column\n}\n\n.lm-ScrollBar-button,.lm-ScrollBar-track {\n    box-sizing: border-box;\n    flex: 0 0 auto\n}\n\n.lm-ScrollBar-track {\n    position: relative;\n    overflow: hidden;\n    flex: 1 1 auto\n}\n\n.lm-ScrollBar-thumb {\n    box-sizing: border-box;\n    position: absolute\n}\n\n.lm-SplitPanel-child {\n    z-index: 0\n}\n\n.lm-SplitPanel-handle {\n    z-index: 1\n}\n\n.lm-SplitPanel-handle.lm-mod-hidden {\n    display: none!important\n}\n\n.lm-SplitPanel-handle:after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    content: ''\n}\n\n.lm-SplitPanel[data-orientation=horizontal]>.lm-SplitPanel-handle {\n    cursor: ew-resize\n}\n\n.lm-SplitPanel[data-orientation=vertical]>.lm-SplitPanel-handle {\n    cursor: ns-resize\n}\n\n.lm-SplitPanel[data-orientation=horizontal]>.lm-SplitPanel-handle:after {\n    left: 50%;\n    min-width: 8px;\n    transform: translateX(-50%)\n}\n\n.lm-SplitPanel[data-orientation=vertical]>.lm-SplitPanel-handle:after {\n    top: 50%;\n    min-height: 8px;\n    transform: translateY(-50%)\n}\n\n.lm-TabBar {\n    display: flex;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.lm-TabBar[data-orientation=horizontal],.lm-TabBar[data-orientation=horizontal]>.lm-TabBar-content {\n    flex-direction: row\n}\n\n.lm-TabBar[data-orientation=vertical],.lm-TabBar[data-orientation=vertical]>.lm-TabBar-content {\n    flex-direction: column\n}\n\n.lm-TabBar-content {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex: 1 1 auto;\n    list-style-type: none\n}\n\n.lm-TabBar-tab {\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    overflow: hidden\n}\n\n.lm-TabBar-tabCloseIcon,.lm-TabBar-tabIcon {\n    flex: 0 0 auto\n}\n\n.lm-TabBar-tabLabel {\n    flex: 1 1 auto;\n    overflow: hidden;\n    white-space: nowrap\n}\n\n.lm-TabBar-tabInput {\n    user-select: all;\n    width: 100%;\n    box-sizing: border-box\n}\n\n.lm-TabBar-tab.lm-mod-hidden {\n    display: none!important\n}\n\n.lm-TabBar.lm-mod-dragging .lm-TabBar-tab {\n    position: relative\n}\n\n.lm-TabBar.lm-mod-dragging[data-orientation=horizontal] .lm-TabBar-tab {\n    left: 0;\n    transition: left 150ms ease\n}\n\n.lm-TabBar.lm-mod-dragging[data-orientation=vertical] .lm-TabBar-tab {\n    top: 0;\n    transition: top 150ms ease\n}\n\n.lm-TabBar.lm-mod-dragging .lm-TabBar-tab.lm-mod-dragging {\n    transition: none\n}\n\n.lm-TabPanel-tabBar {\n    z-index: 1\n}\n\n.lm-TabPanel .lm-TabBar-tab[data-placement=bottom]>.lm-TabBar-content {\n    background: tomato\n}\n\n.lm-TabPanel-stackedPanel {\n    z-index: 0\n}\n\n.lm-BoxPanel,.lm-SplitPanel {\n    flex: 1 1 auto\n}\n\n.lm-DockPanel {\n    padding: 4px\n}\n\n.lm-Panel,body {\n    padding: 0;\n    margin: 0\n}\n\n.lm-DockPanel-widget {\n    box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);\n    border-bottom: 1px solid silver;\n    border-left: 1px solid silver;\n    border-right: 1px solid silver;\n}\n\n.lm-Widget {\n    display: flex\n}\n\nbody {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden\n}\n\n.lm-content,.lm-content>div {\n    flex: 1 1 auto;\n    border: 1px solid silver\n}\n\n.lm-content,.lm-panel,body {\n    display: flex;\n    flex-direction: column\n}\n\n.lm-content,.lm-panel {\n    min-width: 50px;\n    min-height: 50px;\n    height: unset;\n    width: unset;\n    padding: 8px\n}\n\n.lm-content {\n    border-top: none;\n    background: #fff;\n    box-shadow: 1px 1px 2px rgba(0,0,0,.2)\n}\n\n.lm-panel {\n    flex: 1 1 auto\n}\n\n.lm-content>div {\n    overflow: auto;\n    padding: 5px\n}\n\n.lm-DockPanel {\n    box-shadow: inset 0 0 4px 0 rgba(0,0,0,.5)\n}\n\n._dash-loading {\n    position: relative;\n    top: 40vh;\n    left: 40vw;\n    font-size: 50px;\n    color: #888;\n    overflow: hidden;\n    width: 20%;\n    text-align: center\n}\n\n.tabBarContainer {\n    background: #eee;\n    max-width: 35px;\n    min-width: 35px;\n    padding: 7px 0 0\n}\n\n.lm-SideBar {\n    min-width: 35px;\n    max-width: 35px;\n    margin-left: 2px\n}\n\n.lm-SideBar.p-TabBar {\n    min-height: 35px;\n    max-height: 35px;\n    overflow: visible;\n    display: block;\n    min-width: fit-content\n}\n\n.lm-SideBar .p-TabBar-content {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: stretch;\n    list-style-type: none;\n    height: 33px;\n    transform-origin: 0 0 0\n}\n\n.lm-SideBar .p-TabBar-tab {\n    padding: 0 16px;\n    margin-left: -1px;\n    overflow: visible;\n    min-width: fit-content;\n    border: 1px solid #999;\n    transform: translateY(3px)\n}\n\n.lm-SideBar .p-TabBar-tab.p-mod-current {\n    min-height: 32px;\n    max-height: 32px;\n    border-top: 2px solid #119dff\n}\n\n.lm-SideBar .p-TabBar-tabIcon.lm-SideBar-tabIcon {\n    min-width: 28px;\n    min-height: 28px;\n    background-size: 28px;\n    display: inline-block;\n    vertical-align: middle;\n    background-repeat: no-repeat;\n    background-position: center\n}\n\n.lm-SideBar .p-TabBar-tabLabel {\n    margin-top: 3px;\n    transform: rotate(.1deg);\n    margin-right: 6px\n}\n\n.lm-SideBar .p-TabBar-tab:hover:not(.p-mod-current) {\n    background: #eee\n}\n\n.lm-SideBar.p-TabBar.lm-mod-left .p-TabBar-content {\n    flex-direction: row-reverse;\n    transform: rotate(-90deg) translateX(-100%)\n}\n\n.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-content {\n    flex-direction: row;\n    transform: rotate(90deg) translateY(-31px)\n}\n\n.tabBarContainer::after {\n    margin-top: -10px;\n    min-height: 100vh;\n    min-width: 100%;\n    content: \"\";\n    border-right: 1px solid silver;\n    border-left: 1px solid silver;\n    background: 0 0;\n    position: absolute\n}\n\n.lm-SideBar .p-TabBar-tab.p-mod-current {\n    transform: translateY(1px);\n    border-bottom: 1px solid #fff\n}\n\n.lm-SideBar .p-TabBar-tab {\n    border-bottom: 1px solid silver;\n    min-height: 30px;\n    max-height: 30px\n}\n\n.lm-SideBar .p-TabBar-tabIcon {\n    transform: rotate(-90deg);\n    margin: unset\n}\n\n.lm-SideBar .p-TabBar-tabIcon.fa {\n    margin: unset;\n    transform: rotate(90deg) translate(3px,14px);\n    margin-left: 12px\n}\n\n.lm-SideBar.p-TabBar.lm-mod-left .p-TabBar-tab.p-mod-current .p-TabBar-tabIcon {\n    transform: rotate(90deg) translate(2.5px,14.5px)\n}\n\n.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-tabIcon.fa {\n    transform: rotate(-90deg) translate(0,1px)\n}\n\n.lm-SideBar.p-TabBar.lm-mod-right .p-TabBar-tab.p-mod-current .p-TabBar-tabIcon {\n    transform: rotate(-90deg) translate(.5px,1.5px)\n}\n\n.lm-SideBar .p-TabBar-tabLabel:empty {\n    display: none\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
